<template>
  <div class="f-loader-circular" :style="{ '--size': size }">
    <div
      class="shape"
      :class="{ pending: pending || !progress, overlay, completed, error }"
      :style="[progress ? { '--progress': `${progress * 100}%` } : {}]"
    ></div>
    <div class="icon" :class="{ completed, error, overlay }">
      <f-fade-transition mode="out-in">
        <font-awesome-icon
          v-if="completed"
          icon="check"
          key="completed"
          fixed-width
        ></font-awesome-icon>
        <font-awesome-icon
          v-else-if="error"
          icon="close"
          key="error"
          fixed-width
        ></font-awesome-icon>
      </f-fade-transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    overlay: Boolean,
    pending: Boolean,
    progress: { type: Number },
    completed: Boolean,
    error: Boolean,
    size: String,
  },
};
</script>
<style lang="scss">
.f-loader-circular {
  position: relative;
  --size: 20px;

  font-size: var(--size);

  width: var(--size);
  height: var(--size);

  .shape {
    position: absolute;

    width: 1em;
    height: 1em;

    --b: calc(var(--size) * 4 / 20); /* border width*/
    --r: 0.5em; /* the radius */

    color: #313149;
    padding: calc(var(--b) + 5px);
    display: inline-block;
    position: absolute;

    @keyframes f-loader-circular-animation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    &:not(.completed):not(.error):before {
      content: "";
      position: absolute;
      // z-index: -1;
      inset: 0;
      padding: 5px;
      border-radius: 0.5em;

      // mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);

      mask-composite: xor;

      -webkit-mask-image: linear-gradient(#fff 0 0), linear-gradient(#fff 0 0);
      // mask-image: linear-gradient(#fff 0 0), linear-gradient(#fff 0 0);
      mask-position: 0 0, 0 0;
      mask-size: auto, auto;
      mask-repeat: repeat, repeat;
      mask-clip: content-box, border-box;
      mask-origin: content-box, border-box;
      mask-composite: exclude;
      mask-mode: match-source, match-source;

      // mask-composite: exclude;
    }

    &.pending {
      --color1: rgba(22, 22, 21, 0);
      --color2: rgba(22, 22, 21, 1);
      &:before {
        animation: f-loader-circular-animation 1s infinite;
        animation-timing-function: linear;
        background: conic-gradient(
          from 0deg,
          var(--color1) 90deg,
          var(--color2) 360deg
        );
      }

      &.overlay {
        --color1: rgba(255, 255, 255, 0);
        --color2: rgb(255, 255, 255);
      }
    }

    &:not(.pending) {
      --color1: var(--turquoise);
      --color2: var(--black-a5);
      // --color1: red;
      // --color2: green;

      --progress: 75%;

      &:before {
        // --progress: 50%;
        background: conic-gradient(
          from 0deg,
          var(--color1) 0deg,
          var(--color1) var(--progress),
          var(--color2) var(--progress),
          var(--color2) 360deg
        );
      }

      &.overlay {
        --color1: var(--white);
        --color2: var(--white-a10);
      }
    }

    &.completed,
    &.error {
      border-radius: 0.5em;

      color: var(--white);

      &.completed {
        background-color: var(--statusPositive);
      }

      &.error {
        background-color: var(--statusNegative);
      }

      &.overlay {
        &.completed,
        &.error {
          background-color: var(--white);
        }
      }
    }
  }

  .icon {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 0.75em;

    color: white;

    &.overlay {
      color: var(--black);
    }
  }
}

.dark-mode {
  .f-loader-circular {
    .shape {
      color: var(--white-a75);

      &:not(.completed):not(.error):before {
        -webkit-mask-image: linear-gradient(#fff 0 0), linear-gradient(#fff 0 0);
      }

      &.pending {
        --color1: var(--white-a10);
        --color2: var(--white-a75);
        &:before {
          background: conic-gradient(
            from 0deg,
            var(--color1) 90deg,
            var(--color2) 360deg
          );
        }

        &.overlay {
          --color1: rgba(255, 255, 255, 0);
          --color2: rgb(255, 255, 255);
        }
      }

      &:not(.pending) {
        --color1: var(--turquoise);
        --color2: var(--black-a5);

        --progress: 75%;

        &:before {
          background: conic-gradient(
            from 0deg,
            var(--color1) 0deg,
            var(--color1) var(--progress),
            var(--color2) var(--progress),
            var(--color2) 360deg
          );
        }

        &.overlay {
          --color1: var(--white);
          --color2: var(--white-a10);
        }
      }

      &.completed,
      &.error {
        border-radius: 0.5em;

        color: var(--white);

        &.completed {
          background-color: var(--navigation);
        }

        &.error {
          background-color: var(--negative);
        }

        &.overlay {
          &.completed,
          &.error {
            background-color: var(--white-a75);
          }
        }
      }
    }

    .icon {
      color: var(--white-a75);

      &.overlay {
        color: var(--black);
      }
    }
  }
}
</style>